import { Dayjs } from 'dayjs';
import { action, computed, makeObservable } from 'mobx';
import { RangeValue } from 'rc-picker/es/interface';

import { ILocalStore } from 'stores/interfaces';

import { EntryDate, ToServerData } from '../EntryDate';

/** Стор для поля ввода с двумя датами ( от и до )*/
class EntryRangeDate implements ILocalStore {
  constructor() {
    makeObservable<EntryRangeDate>(this, {
      value: computed,
      setValue: action.bound,
    });
  }

  readonly datePickerFrom = new EntryDate({
    required: true,
  });

  readonly datePickerTo = new EntryDate({
    required: true,
  });

  get value(): RangeValue<Dayjs> {
    return [this.datePickerFrom.value, this.datePickerTo.value];
  }

  get toServerFormat(): { from: ToServerData; to: ToServerData } {
    return {
      from: this.datePickerFrom.toServerFormat,
      to: this.datePickerTo.toServerFormat,
    };
  }

  setValue(value: RangeValue<Dayjs>): void {
    if (!value) {
      this.datePickerFrom.reset();
      this.datePickerTo.reset();

      return;
    }

    const [dateFrom, dateTo] = value.values();

    this.datePickerFrom.setValue(dateFrom);
    this.datePickerTo.setValue(dateTo);
  }

  destroy() {
    this.datePickerFrom.destroy();
    this.datePickerTo.destroy();
  }
}

export default EntryRangeDate;
